// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3d_cc","right":"Footer_right__1utUb","buttons":"Footer_buttons__3rwF_"};